module.exports = __webpack_public_path__ + "static/media/Developmenticon04.b3c9f6e6.png";